import { makeSchoolQueryHttp } from '../../_shared/infrastructure/school-query.http';
import type { MySchoolsGateway } from './my-schools.gateway';

/** Client Schools list → the licence-scoped backend route. */
export const httpMySchoolsGateway: MySchoolsGateway = makeSchoolQueryHttp('/schools');
